import React  from 'react'
import DropDown from '../dropdown';
import { PriceLists } from '../../../api/services/next'

const sortedApi = async (params) => {
    const data = await PriceLists.GetClassificationCategories(params);
    if (!Array.isArray(data)) return data;
    return [...data].sort((a, b) => {
        // First sort by DisplayOrder descending
        const orderA = a.DisplayOrder ?? 0;
        const orderB = b.DisplayOrder ?? 0;
        if (orderB !== orderA) return orderB - orderA;
        // Then by Name alphabetically (A-Z)
        return (a.Name || '').localeCompare(b.Name || '');
    });
};

const ClassificationCategoriesDropDown = ({...rest}) => {
    return <DropDown api={sortedApi} search textField="Name" valueField="Id" {...rest}/>
}

export default ClassificationCategoriesDropDown
